import { makeStyles } from "@material-ui/core";
import { BrowserRouter, Route } from 'react-router-dom';
import './App.css';
import Header from './Components/Header';
import CoinPage from './Pages/CoinPage';
import Homepage from './Pages/Homepage';
import Alert from "./Components/Alert";

function App() {

  const useStyles = makeStyles(() => ({
    App: {
      // background:"#14161a",
      background: "#3e3f42",
      color: "white",
      minHeight: "100vh",
    }
  }));

  const classes = useStyles()


  return (

    <BrowserRouter>
    
      <div className={classes.App}>

        
        <Header />

        <Route path='/' component={Homepage} exact />
        <Route path='/coins/:id' component={CoinPage} />

      </div>
      <Alert />
    </BrowserRouter>
    
  )
}

export default App;







